import { render, staticRenderFns } from "./List-vacina.vue?vue&type=template&id=bec10c62&"
import script from "./List-vacina.vue?vue&type=script&lang=js&"
export * from "./List-vacina.vue?vue&type=script&lang=js&"
import style0 from "./List-vacina.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports